import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from './config';
import PlayerSearchDropdown from './PlayerSearchDropdown';
import BottomNavigation from './BottomNavigation';
import '../css/MatchRequest.css';

const storedUser = () => {
  try { return JSON.parse(localStorage.getItem('user') || 'null'); }
  catch { return null; }
};

function MatchRequest() {
  const navigate = useNavigate();
  const user = storedUser();
  const groupId = Number(localStorage.getItem('last_group_id') || user?.group_id || 0);
  const userId = Number(user?.user_id || 0);
  const [mode, setMode] = useState(2);
  const [players, setPlayers] = useState([]);
  const [selected, setSelected] = useState([]);
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!groupId) { setLoading(false); setError('ไม่พบก๊วนที่กำลังใช้งาน กรุณาเช็กอินเล่นวันนี้ก่อน'); return; }
    fetch(`${API_BASE}/api/match-planner/${groupId}/request-options`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` }
    }).then(async response => {
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.message || 'โหลดรายชื่อไม่สำเร็จ');
      setPlayers(result.players || []);
    }).catch(requestError => setError(requestError.message)).finally(() => setLoading(false));
  }, [groupId]);

  const requester = useMemo(() => players.find(player => Number(player.user_id) === userId), [players, userId]);
  const selectable = players.filter(player => Number(player.user_id) !== userId);
  const slotCount = mode - 1;

  const changeMode = nextMode => {
    setMode(nextMode);
    setSelected(current => current.slice(0, nextMode - 1));
    setMessage(''); setError('');
  };

  const updateSlot = (index, player) => {
    setSelected(current => {
      const next = [...current]; next[index] = player; return next;
    });
  };

  const submit = async event => {
    event.preventDefault();
    if (selected.filter(Boolean).length !== slotCount) { setError(`กรุณาเลือกผู้เล่นอีก ${slotCount} คนให้ครบ`); return; }
    setSaving(true); setError(''); setMessage('');
    try {
      const response = await fetch(`${API_BASE}/api/match-planner/${groupId}/requests`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token') || ''}` },
        body: JSON.stringify({ mode, playerIds: selected.map(player => player.user_id), note })
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.message || 'ส่งคำขอไม่สำเร็จ');
      setMessage(mode === 2 ? 'ส่งคำขอคู่ 2 คนแล้ว กรุณารอผู้จัดตรวจสอบและเรียกตามคิว' : 'ส่งคำขอจัดเกม 4 คนแล้ว กรุณารอผู้จัดอนุมัติก่อนเข้าคิว');
      setSelected([]); setNote('');
    } catch (requestError) { setError(requestError.message); }
    finally { setSaving(false); }
  };

  return <div className="mr-page">
    <main className="mr-shell">
      <header className="mr-header"><button type="button" onClick={() => navigate('/profile')}>← ข้อมูลของฉัน</button><div><small>คำขอจัดเกม</small><h1>จัดแมตช์เอง</h1><p>เลือกรายชื่อแล้วส่งให้ผู้จัดตรวจสอบ</p></div></header>
      <section className="mr-explain"><h2>🏸 ผู้เล่นจัดแมตช์ได้อย่างไร?</h2><p><b>คำขอจะยังไม่เข้าคิวทันที</b> ผู้จัดจะตรวจสอบความเหมาะสม สถานะผู้เล่น และเรียกตามลำดับคิว</p><p>กรุณาตรวจชื่อให้ถูกต้อง และคุยยืนยันกับผู้เล่นทุกคนที่เลือกก่อนส่งคำขอ เพื่อป้องกันการเลือกผิดคนหรืออีกฝ่ายยังไม่พร้อม</p></section>
      <form className="mr-form" onSubmit={submit}>
        <h2>เลือกจำนวนผู้เล่น</h2>
        <div className="mr-modes"><button type="button" className={mode===2?'active':''} onClick={() => changeMode(2)}><b>👥 จัดแบบ 2 คน</b><span>ส่งคู่ผู้เล่นเพื่อรอจัดเกม</span></button><button type="button" className={mode===4?'active':''} onClick={() => changeMode(4)}><b>🏸 จัดแบบ 4 คน</b><span>เสนอผู้เล่นครบ 4 คนเพื่อรอผู้จัดอนุมัติ</span></button></div>
        <div className="mr-owner"><span>ผู้ส่งคำขอ</span><b>{requester?.name || user?.name || 'คุณ'}</b></div>
        {loading ? <p className="mr-muted">กำลังโหลดรายชื่อ…</p> : Array.from({length:slotCount}, (_, index) => <label className="mr-slot" key={`${mode}-${index}`}><span>{mode===4 ? `ผู้เล่นคนที่ ${index+2}${index===0?' · คู่ของคุณ':''}` : 'ผู้เล่นที่ต้องการจับคู่'}</span><PlayerSearchDropdown value={selected[index] || null} allPlayers={selectable} usedIds={selected.filter(Boolean).map(player => player.user_id).filter(id => Number(id)!==Number(selected[index]?.user_id))} onChange={player => updateSlot(index, player)} /></label>)}
        <label className="mr-note"><span>หมายเหตุถึงผู้จัด (ไม่บังคับ)</span><textarea value={note} maxLength={255} onChange={event => setNote(event.target.value)} placeholder="เช่น ทุกคนยืนยันแล้ว / ขอเล่นรอบถัดไป" /></label>
        <label className="mr-confirm"><input type="checkbox" required /><span>ฉันตรวจสอบชื่อและยืนยันกับผู้เล่นที่เลือกแล้ว</span></label>
        {error && <p className="mr-error">⚠️ {error}</p>}{message && <p className="mr-success">✅ {message}</p>}
        <button className="mr-submit" disabled={saving || loading || !groupId}>{saving?'กำลังส่ง…':`ส่งคำขอแบบ ${mode} คน`}</button>
      </form>
    </main>
    <BottomNavigation
      active="matches"
      onMonitor={() => navigate('/monitor')}
      onMatches={() => navigate('/match-request')}
      onScan={() => navigate('/profile')}
      onReward={() => navigate('/rewards')}
      onProfile={() => navigate('/profile')}
    />
  </div>;
}

export default MatchRequest;
